export const Achive = () => {
    return (
        <div className="expert" id="expert">
            <div className="container">
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <img src="img/wedo/waterro2.png" className="img-fluid roimg1" alt="ro repair service center" />
                    </div>


                    <div className="col-xs-12 col-md-6">
                        <div className="roimg2">
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-md-6">
                                    <div className="whymrwater">
                                        <div className="imgicon">
                                            <img src="img/wedo/clock.png" alt="ro repair in hyderabad" />
                                        </div>
                                        <div className="icontext">
                                            <h5>Timely Assistance</h5>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-6">
                                    <div className="whymrwater">
                                        <div className="imgicon">
                                            <img src="img/wedo/guarantee-v2.png " alt="ro service in hyderabad" />
                                        </div>
                                        <div className="icontext">
                                            <h5>Expert Technicians</h5>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-6">
                                    <div className="whymrwater">
                                        <div className="imgicon">
                                            <img src="img/wedo/insurance.png" alt="ro repair in hyderabad" />
                                        </div>
                                        <div className="icontext">
                                            <h5>Only Genuine Spare Parts</h5>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-6">
                                    <div className="whymrwater">
                                        <div className="imgicon">
                                            <img src="img/wedo/price.png" alt="kent customer number" />
                                        </div>
                                        <div className="icontext">
                                            <h5>Fixed Rate for spare parts</h5>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-6">
                                    <div className="whymrwater">
                                        <div className="imgicon">
                                            <img src="img/wedo/service-v2.png" alt="ro customer care number" />
                                        </div>
                                        <div className="icontext">
                                            <h5>4,000+ Service Request Completed</h5>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-6">
                                    <div className="whymrwater">
                                        <div className="imgicon">
                                            <img src="img/wedo/trained.png" alt="ro phone number in hyderabad" />
                                        </div>
                                        <div className="icontext">
                                            <h5>Expert & Professional Technicians</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}